<template>
  <div class="w-full h-full flex flex-col">
    <iframe
      v-if="appUrl"
      :src="appUrl"
      class="w-full flex-1 border-0"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    />
    <div v-else class="flex items-center justify-center h-full text-slate-500">
      No hay aplicaciones configuradas en el menú.
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();

const records = computed(() => store.getters['sidebarApps/getRecords'] || []);

const appUrl = computed(() => {
  const appId = Number(route.params.appId);
  const app = records.value.find(a => a.id === appId);
  if (!app) return null;

  const url = new URL(app.url);
  const user = store.getters.getCurrentUser || {};
  url.searchParams.set('cw_user_id', user.id || '');
  url.searchParams.set('cw_user_name', user.name || '');
  url.searchParams.set('cw_user_email', user.email || '');
  url.searchParams.set('cw_account_id', route.params.accountId || '');
  return url.toString();
});
</script>
